<div
  class="alert alert-dismissible fade show"
  [class.alert-success]="alert().type === 'success'"
  [class.alert-info]="alert().type === 'info'"
  [class.alert-warning]="alert().type === 'warning'"
  [class.alert-danger]="alert().type === 'error'"
  role="alert"
  [attr.aria-live]="alert().type === 'error' ? 'assertive' : 'polite'"
  [attr.aria-atomic]="true"
>
  @if (alert().duration) {
    <div
      class="alert-progress"
      [style.animation-duration.ms]="alert().duration"
    ></div>
  }

  @if (alert().dismissible) {
    <button
      type="button"
      class="btn-close"
      (click)="handleDismiss()"
      [attr.aria-label]="'Dismiss ' + (alert().title || 'alert')"
    ></button>
  }

  <div class="alert-content">
    @if (alert().title) {
      <h4 class="alert-heading">{{ alert().title }}</h4>
    }
    <p class="mb-0">{{ alert().message }}</p>
  </div>

  @if (alert().actions?.length) {
    <div class="alert-actions mt-2">
      @for (action of alert().actions; track action) {
        <button
          type="button"
          [class]="getActionClass(action.style)"
          (click)="handleAction(action)"
          [attr.aria-label]="action.label"
        >
          @if (action.icon) {
            <i [class]="action.icon" aria-hidden="true"></i>
          }
          {{ action.label }}
        </button>
      }
    </div>
  }
</div>
